import styled from "styled-components";

export const Card = styled.div`
  display: flex;
  flex-direction: column;
  background: ${({ theme }) => theme.palette.white};
  border: 1px solid ${({ theme }) => theme.palette.borderLight};
  border-radius: 14px;
  padding: 22px 20px 18px;
  transition: all 0.25s ease;
  cursor: default;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 10px 28px ${({ theme }) => theme.palette.shadowSm};
    border-color: ${({ theme }) => theme.palette.primaryBorder};
  }
`;

export const CardEmoji = styled.div`
  font-size: 2.4rem;
  line-height: 1;
  margin-bottom: 14px;
`;

export const CardName = styled.div`
  font-size: 1rem;
  font-weight: 700;
  color: ${({ theme }) => theme.palette.textPrimary};
  margin-bottom: 6px;
`;

export const CardDesc = styled.div`
  font-size: 0.85rem;
  color: ${({ theme }) => theme.palette.textSecondary};
  line-height: 1.55;
  flex: 1;
`;

export const CardRegion = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  margin-top: 12px;
  font-size: 0.75rem;
  font-weight: 600;
  color: ${({ theme }) => theme.palette.primary};
  background: ${({ theme }) => theme.palette.primarySubtle};
  padding: 3px 10px;
  border-radius: 20px;
  align-self: flex-start;
`;
